module.exports = __webpack_public_path__ + "static/media/roma-cover.aa1aded9.jpeg";